@if (visible()) {
  <span
    class="cart-countdown"
    [class.cart-countdown--urgente]="urgente()"
    [title]="mensaje()"
    [attr.aria-label]="mensaje()"
  >
    {{ texto() }}
  </span>
}
